// ============================================
// SUBDOMAIN REDIRECT COMPONENT
// Automatically redirects users based on subdomain
// ============================================

import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { isCaisseSubdomain, isClientSubdomain, getSubdomain } from '../utils/subdomainRouter';

/**
 * Component that handles automatic redirection based on subdomain
 * Place this inside BrowserRouter but before Routes
 */
const SubdomainRedirect = () => {
    const navigate = useNavigate();
    const location = useLocation();
    
    useEffect(() => {
        const subdomain = getSubdomain();
        const currentPath = location.pathname;
        
        // Skip if already on correct path or special paths
        const skipPaths = ['/reservation-action', '/fidelite'];
        if (skipPaths.some(p => currentPath.startsWith(p))) {
            return;
        }
        
        // If on caisse subdomain and at root, redirect to login
        if (isCaisseSubdomain() && currentPath === '/') {
            navigate('/login', { replace: true });
            return;
        }
        
        // If on client subdomain (or www/no subdomain) and at root, redirect to client
        if (isClientSubdomain() && currentPath === '/') {
            navigate('/client', { replace: true });
            return;
        }
        
        // If on client subdomain and trying to access internal pages without auth
        // This is handled by ProtectedRoute, so we don't need to do anything here
        
    }, [location.pathname, navigate]);
    
    return null; // This component doesn't render anything
};

export default SubdomainRedirect;
